import { useState } from "react";
import ApiService from "../../services/ApiServiceClass";

export const useGetRequestDetailsByID = (requestID: number) => {
    
    const fetchRequestsDetailsByID = async () => {

        try {
            const responseData = await ApiService.getRequestDetailsByID(requestID);
            return responseData.data;            
        } catch(error) {
            throw(error);
        }
    }

    return {fetchRequestsDetailsByID};
}
